var _defs, _g, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOutsideSchoolCatchment(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 44,
    height: 45,
    viewBox: "0 0 44 45",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "a",
    cx: "0%",
    r: "192.58%",
    fx: "0%",
    fy: "50%",
    gradientTransform: "matrix(0 -1 .88152 0 -.44 .5)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#070707",
    stopOpacity: 0.781
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "48.585%",
    stopColor: "#070707",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: "50%",
    x2: "50%",
    y1: "97.024%",
    y2: "38.363%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#FFF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#FFF",
    stopOpacity: 0.4
  })), /*#__PURE__*/React.createElement("path", {
    id: "b",
    d: "M15.19 38.738L4.449 25.604a14.864 14.864 0 0 1 0-21.211c5.932-5.858 15.55-5.857 21.482 0a14.865 14.865 0 0 1 0 21.21L15.19 38.739z"
  }))), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#a)",
    d: "M30.588 33.41c3.242.587 13.61-5.436 13.61-8.928 0-3.491-1.21-8.105-13.091-8.105S9.074 23.39 9.145 24.812c.07 1.423 18.2 8.01 21.443 8.597z",
    opacity: 0.524,
    style: {
      mixBlendMode: "multiply"
    },
    transform: "rotate(-50 31.388 23.197)"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(3 3)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#FFF",
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "url(#c)",
    strokeWidth: 2,
    d: "M3.708 26.277a15.864 15.864 0 0 1 .039-22.596c6.32-6.242 16.565-6.241 22.887 0a15.865 15.865 0 0 1 .038 22.596L15.19 40.317 3.708 26.277z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#DB0F00",
    strokeLinejoin: "square",
    strokeWidth: 2,
    d: "M15.19 37.158l9.967-12.187.072-.079a13.865 13.865 0 0 0 0-19.787c-5.543-5.473-14.535-5.473-20.077 0a13.864 13.864 0 0 0 0 19.787l.071.079 9.967 12.187z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#DB0F00",
    d: "M18.143 11.027a.378.378 0 0 0-.283 0l-8.819 3.555c-.22.093-.374.38-.374.707 0 .327.154.613.374.707l3.26 1.314.098 6.331c0 .266.103.51.264.64.166.13.407.147.526-.015.455-.625 3.471-.921 5.095-.921 1.625 0 2.986.14 4.625 1.56.084.072.334.165.525.014.166-.13.265-.374.265-.639v-6.97l1.716-.691v4.063c0 .405.232.733.518.733.287 0 .518-.328.518-.733v-4.484l.508-.202c.223-.089.374-.38.374-.707 0-.328-.154-.614-.374-.707l-8.816-3.555z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOutsideSchoolCatchment);
export default __webpack_public_path__ + "static/media/outside_school_catchment.52b68e783531afe7bd06d3ff53f9eda3.svg";
export { ForwardRef as ReactComponent };